// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spotlight-card-corner-tag[data-v-505dbe14]{color:#657182;font-weight:900;font-size:16px;line-height:20px;background-color:#f7f7f8;padding:10px 24px;border-radius:0 20px;position:absolute;top:-16px;right:-16px;width:-moz-max-content;width:max-content}.spotlight-card-corner-tag--small[data-v-505dbe14]{font-size:16px;padding:8px 12px}@media(max-width:991px){.spotlight-card-corner-tag[data-v-505dbe14]{font-size:14px;padding:8px 12px}}", ""]);
// Exports
module.exports = exports;
